// Unpublished Work © 2023 Deere & Company.
export const removeURLParams = () => {
  const url = window.location.href;
  if (url.indexOf("?") > 0) {
    const urlWithoutParams = url.substring(0, url.indexOf("?"));
    window.history.pushState({}, document.title, urlWithoutParams);
  }
};

export const getAccountIdFromUrl = (
  pathname: string,
  search: string | undefined
) => {
  let accountId;
  // if (!pathname.includes("claim")) [, , accountId] = pathname.split("/");

  if (pathname.includes("dealer")) [, , accountId] = pathname.split("/");
  if (accountId === undefined || accountId === null) {
    if (search && search.includes("accountId=")) {
      [accountId] = search.split("accountId=")[1].split("&");
    }
  }
  return accountId;
};
